import { Component } from '@angular/core';
import { SupervisorService } from 'src/app/services/supervisor.service';
import { Supervisor } from 'src/app/models/supervisor.interface';
import { CasoClinico } from 'src/app/models/caso-clinico.interface';
import { AuthService } from 'src/app/services/auth.service';
import { Paginar } from 'src/app/models/http-paginacion.interface';
@Component({
  selector: 'app-supervisor-casosclinicos',
  templateUrl: './supervisor-casosclinicos.component.html',
  styleUrls: ['./supervisor-casosclinicos.component.scss']
})
export class SupervisorCasosclinicosComponent {
  supervisor!: Supervisor;
  casosclinicos: CasoClinico[] = [];
  casosclinicosTmp: CasoClinico[] = [];
  currentPageCasosClinicos: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsCasosClinicos: number = 10;
  constructor(private supervisorService: SupervisorService, private authService: AuthService) {

    if (this.authService.isLoggedIn) {
      const id: number | undefined = this.authService.getUsuario?.supervisor?.id;
      if (id) this.obtenerInformacion(id);
    }

  }
  obtenerInformacion(id: number): void {
    this.supervisorService.getSupervisor(id).subscribe({
      next: (resp) => {
        this.casosclinicos = resp.datos.casosclinicos;
        this.casosclinicosTmp.push(...resp.datos.casosclinicos);
        this.supervisor = resp.datos;
        this.totalItemsCasosClinicos = this.casosclinicosTmp.length;
        //  console.log(resp)
      },
      error: (err) => console.log(err)
    });
  }
  get casosClinicos(): CasoClinico[] {
    const startIndex = (this.currentPageCasosClinicos.page) * this.currentPageCasosClinicos.rows;
    return this.casosclinicosTmp.slice(startIndex, startIndex + this.currentPageCasosClinicos.rows);
  }
  get totalPaginasCasosClinicos(): number {
    return Math.ceil(this.supervisor.casosclinicos.length / this.currentPageCasosClinicos.rows);
  }
  onPageChangeCasosClinicos(event: any) {
    this.currentPageCasosClinicos = <Paginar>event;
  }
}
